import { IRemoteRepository, DataResponse , Benefit } from '../../index'

export class GetShirtImagesUseCase {
    readonly remoteRepository: IRemoteRepository;

    constructor(remoteRepository: IRemoteRepository) {
        this.remoteRepository = remoteRepository;
    }

    async execute(): Promise<DataResponse<{first: string, second: string}>> {
        return await this.remoteRepository.fetchShirtImages();
    }
}